import { ObjectUtils } from '../object';

export interface ContentTrimWindow extends Window {
    DWSContentTrim?: ContentTrim;
}

export class ContentTrim {

    public static id: string = 'DWSContentTrim';

    public static getInstance(): ContentTrim {
        const windowRef: ContentTrimWindow = window as ContentTrimWindow & typeof globalThis;

        if (!windowRef) {
            throw new Error('No DOM window present in the execution environment! Aborting.');
        }

        if (this.instance) {
            return this.instance;
        }

        if (windowRef[this.id] !== undefined) {
            this.instance = windowRef[this.id];
            return windowRef[this.id];
        }

        this.instance = new ContentTrim();
        (window as ContentTrimWindow & typeof globalThis)[this.id] = this.instance;

        return this.instance;
    }

    private static instance: ContentTrim;

    private trimCutoff: number = 120;

    public async initTrim(): Promise<void> {
        const collection = document.querySelectorAll('[data-js="trimmed-content"]');

        collection.forEach((element: Element) => {
            if ((element as HTMLElement).innerText.length <= this.trimCutoff) {
                return;
            }

            const content = ObjectUtils.clone(element.innerHTML);
            const triggerHTML = '<a data-js="trimmed-content-trigger" class="a-link">'
                + element.getAttribute('data-link-translation')
                + '</a>';

            element.innerHTML = (element as HTMLElement).innerText.slice(0, this.trimCutoff) + '&hellip; ' + triggerHTML;
            element.querySelector('[data-js="trimmed-content-trigger"]')!.addEventListener('click', (event) => {
                element.innerHTML = content;
            });
        });
    }
}
